import { PROMOTION_TYPES } from '@/domainLogic/index.ts';
import type { FC } from 'react';
import LoyaltyBadge from '@/app/components/search/components/EvolutionCard/Badges/badges/LoyaltyBadge.tsx';
import type { BadgeContext } from './types';
import { BADGE_SLOTS } from './types';
import FlashSalesCountdownBadge from './badges/FlashSalesCountdownBadge';
import { HOTEL_THEME, KIDS_STAY_FREE, MY_PRICE_DISCOUNT, WELCOME_GIFT_OFFER } from './localPromotionTypes';
import PinkPeopleBadge from './badges/PinkPeopleBadge';
import { AppOnlyPriceBadge, MobileOnlyPriceBadge } from './badges/MobilePriceBadges';
import TopSecretHotelsBadge from './badges/TopSecretHotelsBadge';
import GalleryFlashSalesBadge from '../Gallery/FlashSalesBadge';
import PeriodicBadge from './badges/PeriodicBadges';
import JanuarySaleBadge from './badges/JanuarySaleBadge';
import ToWegdeBadge from './badges/ToWegdeBadge';
import ToLastminuteBadge from './badges/ToLastminuteBadge';
import TourOperatorLogoBadge from './badges/TourOperatorLogoBadge';
import VoucherExtraBadge from './badges/VoucherExtraBadge';
import PackageSavingsBadge from './badges/PackageSavingsBadge';
import VoucherNearPriceBadge from './badges/VoucherNearPriceBadge';
import MyPriceBadge from './badges/MyPriceBadge';
import MyPriceDiscountBadge from './badges/MyPriceDiscountBadge';
import TicketsBadge from './badges/TicketsBadge';
import SpaBadge from './badges/SpaBadge';
import SkiPassBadge from './badges/SkiPassBadge';
import ResortCreditBadge from './badges/ResortCreditBadge';
import CardGalleryFlashSalesBadge from './badges/CardGalleryFlashSalesBadge';
import HotelThemeBadge from './badges/HotelThemeBadge';
import KidsStayFreeBadge from './badges/KidsStayFreeBadge';
import WelcomeGiftOfferBadge from './badges/WelcomeGiftOfferBadge';

export const BADGE_SLOT_LIMITS: Record<BADGE_SLOTS, number> = {
  [BADGE_SLOTS.DEAL_HIGHLIGHTS]: 2,
  [BADGE_SLOTS.GALLERY_OVERLAY]: 2,
  [BADGE_SLOTS.GALLERY_OVERLAY_OLD]: 2,
  [BADGE_SLOTS.PRICE_ADDONS]: 1,
  [BADGE_SLOTS.HOTEL_HEADER]: 1,
};

export const BADGE_CONFIG: Record<BADGE_SLOTS, Partial<Record<PROMOTION_TYPES, FC<BadgeContext>>>> = {
  [BADGE_SLOTS.DEAL_HIGHLIGHTS]: {
    [PROMOTION_TYPES.FLASH_SALES]: FlashSalesCountdownBadge,
    [PROMOTION_TYPES.PINK_PEOPLE]: PinkPeopleBadge,
    [PROMOTION_TYPES.APP_ONLY_PRICE]: AppOnlyPriceBadge,
    [PROMOTION_TYPES.MOBILE_ONLY_PRICE]: MobileOnlyPriceBadge,
    [PROMOTION_TYPES.BLACK_FRIDAY]: () => <PeriodicBadge promotionType={PROMOTION_TYPES.BLACK_FRIDAY} />,
    [PROMOTION_TYPES.CYBER_MONDAY]: () => <PeriodicBadge promotionType={PROMOTION_TYPES.CYBER_MONDAY} />,
    [PROMOTION_TYPES.TRAVEL_TUESDAY]: () => <PeriodicBadge promotionType={PROMOTION_TYPES.TRAVEL_TUESDAY} />,
    [PROMOTION_TYPES.SUMMER_SALE]: () => <PeriodicBadge promotionType={PROMOTION_TYPES.SUMMER_SALE} />,
    [PROMOTION_TYPES.JANUARY_SALE]: JanuarySaleBadge,
    [PROMOTION_TYPES.TO_WEGDE]: ToWegdeBadge,
    [PROMOTION_TYPES.TO_LOGO]: TourOperatorLogoBadge,
    [PROMOTION_TYPES.TO_LASTMINUTE]: ToLastminuteBadge,
    [PROMOTION_TYPES.VOUCHER_EXTRA]: VoucherExtraBadge,
    // Last: the slot takes two badges, and these claimed them before HO had this one.
    [PROMOTION_TYPES.MY_PRICE]: MyPriceBadge,
  },

  [BADGE_SLOTS.GALLERY_OVERLAY]: {
    [PROMOTION_TYPES.FLASH_SALES]: GalleryFlashSalesBadge,
    [KIDS_STAY_FREE]: KidsStayFreeBadge,
    [PROMOTION_TYPES.TICKETS]: TicketsBadge,
    [PROMOTION_TYPES.SPA]: SpaBadge,
    [PROMOTION_TYPES.SKIPASS]: SkiPassBadge,
    [PROMOTION_TYPES.RESORT_CREDIT]: ResortCreditBadge,
    [WELCOME_GIFT_OFFER]: WelcomeGiftOfferBadge,
    [HOTEL_THEME]: HotelThemeBadge,
    [PROMOTION_TYPES.TOP_SECRET_HOTELS]: TopSecretHotelsBadge,
  },

  [BADGE_SLOTS.GALLERY_OVERLAY_OLD]: {
    [PROMOTION_TYPES.FLASH_SALES]: CardGalleryFlashSalesBadge,
    [KIDS_STAY_FREE]: KidsStayFreeBadge,
    [WELCOME_GIFT_OFFER]: WelcomeGiftOfferBadge,
    [HOTEL_THEME]: HotelThemeBadge,
  },

  [BADGE_SLOTS.PRICE_ADDONS]: {
    [PROMOTION_TYPES.VOUCHER]: VoucherNearPriceBadge,
    [PROMOTION_TYPES.PACKAGE_SAVINGS]: PackageSavingsBadge,
    // Last: the slot takes one badge and a voucher claimed it before HO had this one.
    [MY_PRICE_DISCOUNT]: MyPriceDiscountBadge,
  },

  [BADGE_SLOTS.HOTEL_HEADER]: {
    [PROMOTION_TYPES.LOYALTY]: LoyaltyBadge,
  },
};
